import {openAlert, openConfirm} from "../components/Modal/MsgBox";
import { deleteUserToken } from "./useLogin";

export const fetchGet = (url, afterFetch = () => {}, afterCatch = () => {
}) => {
    // fetch get -> 200이면 json 리턴하여 데이터 사용, 400이면 json.message 이용하여 alert 오픈
    // api 연동이 포함된 로직인 경우, 504 또는 502 timeout일 때 api 문제임을 보여줌.
    // 이외 500 오류인 경우 데이터를 불러올 수 없음을 보여줌.
    fetch(`/api-tlo${url}`, {}).then((res) => {
        if (res.status === 200 || res.status === 400) {
            return res.json();
        } else if(res.status === 504 || res.status === 502) {
            if (res.headers.get("Content-Type").includes("application/json")) {
                const json = res.json();
                return new Error(json.message);
            }
            throw new Error("데이터를 불러올 수 없습니다.");
        } else if (res.status === 401) {
            deleteUserToken();
            res.json().then(json => openAlert(json.message, () => window.location.href = '/account/login'));
        } else if (res.status === 403) {
            res.json().then(json => openAlert(json.message, () => window.location.href = '/mypage'));
        } else {
            throw new Error("데이터를 불러올 수 없습니다.");
        }
    }).then(json => {
        if(json.message !== undefined) {
            if(json.message.includes("사용자를 찾을 수 없습니다.")) {
                openAlert(json.message, () => window.location.reload());
            } else {
                openAlert(json.message, afterCatch);
            }
        } else {
            afterFetch(json);
        }
    }).catch(e => {
        openAlert(e.message, afterCatch);
    });
}

export const fetchPost = (url, msg, body, afterSuccess = () => {}, isJson = true, afterPost = () => {}, callback = () => {}, isNew = true) => {
    // fetch post -> 201이면 성공(post 요청 성공 시 201로 리턴), 성공 이후에 afterSuccess 실행, 400이면 json.message 이용하여 alert 오픈
    // api 연동이 포함된 로직인 경우, 504 또는 502 timeout일 때 api 문제임을 보여줌.
    // 이외 500 오류인 경우 해당 post를 진행할 수 없음을 보여줌
    // 이후 성공이든 실패든 해야하는 로직이 있다면 afterPost 실행
    const headers = isJson ? {"Content-Type": "application/json; charset=UTF-8"} : {}
    const typedBody = isJson ? JSON.stringify(body) : body;
    fetch(`/api-tlo${url}`, {
        method: "POST",
        headers: headers,
        body: typedBody
    }).then(res => {
        // clicked.current = false;
        if (res.status === 201) {
            openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess);
        } else if(res.status === 504 || res.status === 400) {
            if (res.headers.get("Content-Type").includes("application/json")) {
                res.json().then(json => openAlert(json.message + "\n" + msg + " 할 수 없습니다.", afterPost));
                return;
            }
            throw new Error(msg + " 할 수 없습니다.");
        } else if (res.status === 401) {
            deleteUserToken();
            res.json().then(json => openAlert(json.message, () => window.location.href = '/account/login'));
        } else if (res.status === 403) {
            res.json().then(json => openAlert(json.message, () => window.location.href = '/mypage'));
        } else if (res.status === 200) {
            openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess);
        } else if (res.status === 302) {
            res.json().then(json => openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess(json.userId)))
        } else {
            throw new Error(msg + " 할 수 없습니다.");
        }
    }).catch(e => {
        openAlert(e.message, afterPost);
    }).finally(e => {
        callback();
    });
}

export const fetchPostWithFiles = (url, msg, body, afterSuccess = () => {}, afterPost = () => {}, callback = () => {}, isNew = true) => {
    // fetch post -> 201이면 성공(post 요청 성공 시 201로 리턴), 성공 이후에 afterSuccess 실행, 400이면 json.message 이용하여 alert 오픈
    // api 연동이 포함된 로직인 경우, 504 또는 502 timeout일 때 api 문제임을 보여줌.
    // 이외 500 오류인 경우 해당 post를 진행할 수 없음을 보여줌
    // 이후 성공이든 실패든 해야하는 로직이 있다면 afterPost 실행
    fetch(`/api-tlo${url}`, {
        method: "POST",
        body: body      // formData 형태로 전송해야함
    }).then(res => {
        // clicked.current = false;
        if (res.status === 201) {
            openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess);
        } else if(res.status === 504 || res.status === 400) {
            if (res.headers.get("Content-Type").includes("application/json")) {
                res.json().then(json => openAlert(json.message + "\n" + msg + " 할 수 없습니다.", afterPost));
                return;
            }
            throw new Error(msg + " 할 수 없습니다.");
        } else if (res.status === 401) {
            deleteUserToken();
            res.json().then(json => openAlert(json.message, () => window.location.href = '/account/login'));
        } else if (res.status === 403) {
            res.json().then(json => openAlert(json.message, () => window.location.href = '/mypage'));
        } else if (res.status === 200) {
            openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess);
        } else if (res.status === 302) {
            res.json().then(json => openAlert(`${msg}${isNew ? " 했습니다." : "합니다."}`, afterSuccess(json.userId)))
        } else {
            throw new Error(msg + " 할 수 없습니다.");
        }
    }).catch(e => {
        openAlert(e.message, afterPost);
    }).finally(e => {
        callback();
    });
}

export const fetchPut = (url, msg, body, afterPut, isJson = true, afterCatch = () => {}) => {
    // fetch put -> 201이면 성공, 성공 이후 로직을 실행. 400이면 json.message 이용하여 alert 오픈
    // api 연동이 포함된 로직인 경우, 504 또는 502 timeout일 때 api 문제임을 보여줌.
    const headers = isJson ? {"Content-Type": "application/json; charset=UTF-8"} : {}
    const typedBody = isJson ? JSON.stringify(body) : body;
    fetch(`/api-tlo${url}`, {
        method: "PUT",
        headers: headers,
        body: typedBody
    }).then(res => {
        // clicked.current = false;
        if (res.status === 200 || res.status === 204) {
            openAlert(msg + "했습니다.", afterPut);
        } else if(res.status === 504 || res.status === 400) {
            if (res.headers.get("Content-Type").includes("application/json")) {
                res.json().then(json => openAlert(json.message, afterCatch));
                return;
            }
            throw new Error(msg + "할 수 없습니다.");
        } else if (res.status === 401) {
            deleteUserToken();
            res.json().then(json => openAlert(json.message, () => window.location.href = '/account/login'));
        } else if (res.status === 403) {
            res.json().then(json => openAlert(json.message, () => window.location.href = '/mypage'));
        } else {
            throw new Error(msg + "할 수 없습니다.");
        }
    }).catch(e => {
        openAlert(e.message, afterCatch);
    });
}

export const fetchDel = (url, msg, confirmMsg, clicked, afterDel=()=>{}) => {
    // fetch delete -> 201이면 성공으로 리턴시키고 있음. 해당 요청 성공 시 afterDel 사용. 400이면 json.message 이용하여 alert 오픈
    // api 연동이 포함된 로직인 경우, 504 또는 502 timeout일 때 api 문제임을 보여줌.
    // 이외 500 오류인 경우 삭제할 수 없음을 보여줌.
    const deleteFetch = () => {
        fetch(`/api-tlo${url}`, {
            method: "DELETE"
        }).then(res => {
            clicked.current = false;
            if (res.status === 200) {
                openAlert(msg + " 삭제했습니다.", afterDel);
            } else if(res.status === 504 || res.status === 400) {
                if (res.headers.get("Content-Type").includes("application/json")) {
                    res.json().then(json => openAlert(json.message));
                    return;
                }
                throw new Error("삭제할 수 없습니다.");
            } else if (res.status === 401) {
                deleteUserToken();
                res.json().then(json => openAlert(json.message, () => window.location.href = '/account/login'));
            } else if (res.status === 403) {
                res.json().then(json => openAlert(json.message, () => window.location.href = '/mypage'));
            } else {
                throw new Error(" 삭제할 수 없습니다.");
            }
        }).catch(e => {
            openAlert(e.message);
        });
    }
    openConfirm(
        confirmMsg,
        deleteFetch,
        () => {
            clicked.current = false;
        }
    );
}


export const fetchLogin = (body, afterSuccess = () => {}) => {
    fetch(`/api-tlo/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(body),
    }).then(res => {
        if (res.status === 200) {
            openAlert(`로그인 되었습니다.`, afterSuccess);
        } else if(res.status === 400) {
            res.json().then(json => openAlert(json.message));
        } else {
            throw new Error("로그인 할 수 없습니다.");
        }
    }).catch(e => {
        openAlert(e.message);
    });
}
